module.exports = __webpack_public_path__ + "img/sv92.ac2b18c5.svg";